import { ImageEffects } from './store/effects/image.effects';
import { FloorPlanEffects } from './store/effects/floorplan.effects';
import { MessageService } from 'primeng/api';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppComponent } from './app.component';
import { SvgEditorComponent } from './svg-editor/svg-editor.component';
import { ContainerComponent } from './container/container.component';
import { TopPanelComponent } from './container/top-panel/top-panel.component';
import { LeftPanelComponent } from './container/left-panel/left-panel.component';
import { RightPanelComponent } from './container/right-panel/right-panel.component';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { MiddlewareService } from './services/middleware.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRequestInterceptor } from './interceptors/http-request-interceptor';
import { AuthService } from './services/auth.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageComponent } from './shared/message/message.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { MsgService } from './services/message.service';
import { LoaderService } from './services/loader.service';
import { AppInitService } from './app-init.service';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { PrintService } from './services/print.service';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { floorplanReducer } from './store/reducers/floorplan.reducer';
import { environment } from 'src/environments/environment';
import { imageReducer } from './store/reducers/image.reducer';
import { datiUIUReducer } from './store/reducers/dati-uiu.reducer';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';
import { PrintModalComponent } from './shared/print-modal/print-modal.component';
import { ConfirmModalComponent } from './shared/confirm-modal/confirm-modal.component';

export function initializeApp(appInitService: AppInitService) {
  return (): Promise<any> => { 
    return appInitService.Init();
  }
}

@NgModule({
  declarations: [
    AppComponent,
    SvgEditorComponent,
    ContainerComponent,
    TopPanelComponent,
    LeftPanelComponent,
    RightPanelComponent,
    LoaderComponent,
    MessageComponent,
    PrintModalComponent,
    ConfirmModalComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    FlexLayoutModule,
    ButtonModule,
    ToolbarModule,
    PanelModule,
    FontAwesomeModule,
    RadioButtonModule,
    DropdownModule,
    ProgressSpinnerModule,
    ToastModule,
    TableModule,
    InputTextModule,
    CheckboxModule,
    TooltipModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    StoreModule.forRoot({
      floorPlan: floorplanReducer, 
      image: imageReducer,
      datiUIU: datiUIUReducer
    }),
    EffectsModule.forRoot([FloorPlanEffects, ImageEffects]),
    !environment.production ? StoreDevtoolsModule.instrument() : []
  ],
  providers: [
    AuthService,
    MiddlewareService,
    LoaderService,
    MessageService,
    ConfirmationService,
    MsgService,
    PrintService,
    DialogService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    AppInitService,
    { provide: APP_INITIALIZER,useFactory: initializeApp, deps: [AppInitService], multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
